const errorActionPrefix = "error on"
const successActionPrefix = "success on"

const buildActionName = (action: string, prefix: string): string => {
  return `${prefix} ${action}`
}

export const AnalyticsActionName = {
  DataUploadBuildingDataError: buildActionName(
    "Upload Building Data",
    errorActionPrefix
  ),
  DataUploadBuildingDataSuccess: buildActionName(
    "Upload Building Data",
    successActionPrefix
  ),
  DataUploadMeterDataError: buildActionName(
    "Upload Meter Data",
    errorActionPrefix
  ),
  DataUploadMeterDataSuccess: buildActionName(
    "Upload Meter Data",
    successActionPrefix
  ),
  DataUploadUsageDataError: buildActionName(
    "Upload Usage Data",
    errorActionPrefix
  ),
  DataUploadUsageDataSuccess: buildActionName(
    "Upload Usage Data",
    successActionPrefix
  ),
  DataUploadIntervalUsageDataError: buildActionName(
    "Upload Interval Usage Data",
    errorActionPrefix
  ),
  DataUploadIntervalUsageDataSuccess: buildActionName(
    "Upload Interval Usage Data",
    successActionPrefix
  ),
  DataUploadUserDataError: buildActionName(
    "Upload User Data",
    errorActionPrefix
  ),
  DataUploadUserDataSuccess: buildActionName(
    "Upload User Data",
    successActionPrefix
  ),
  DownloadCsv: "Download CSV",
}
